import React from 'react'
import { useRole } from "./role"
const RoleContext = React.createContext()

export const RoleContextProvider = ({children}) => {
  const ROLE = useRole()

  return (
    <RoleContext.Provider value={{...ROLE}}>
      {children}
    </RoleContext.Provider>
  )

}
export default RoleContext